import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _BudgetAccountantOperation, _SubMacroProcess } from '../../../../core/services/dataBean/EntityCatalog';
import { _CustomProcessType } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { toast } from 'react-toastify';



interface Props {

    idSelector: number;
    onChange: any;
    label?: string;
}

export const BudgetAccountantOperationSelect = ({ idSelector, onChange, label }: Props) => {


    const { lista, setLista, bean, setBean, instance, handleChange, deleteItemVoid } = useDataBean(_BudgetAccountantOperation);
    // const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector)
        }
    }, [])

    useEffect(() => {
        getLista();
    }, [])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        instance.getBudgetAccountantOperationCatalog(null).then(
            (resp) => {
                setLista(resp);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }


    return (
        <>
            <label>{label ?? "Catálogo de Servicios Contable-Presupuestales"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>

                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDBudgetAccountantOperation} >
                                {item.DataBeanProperties.Code} - {item.DataBeanProperties.Name}
                                </option>
                        )
                    })
                }
            </select>
        </>
    )
}